module.exports = __webpack_public_path__ + "static/media/slider-icon.2b168a8a.png";